import { render, staticRenderFns } from "./Texture.vue?vue&type=template&id=2efbe3c0&scoped=true&"
import script from "./Texture.vue?vue&type=script&lang=js&"
export * from "./Texture.vue?vue&type=script&lang=js&"
import style0 from "./Texture.vue?vue&type=style&index=0&id=2efbe3c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efbe3c0",
  null
  
)

export default component.exports